import { useClient } from 'hooks/useClient';
import { IDocumentPostMetadata } from '@cincel/client';
import { useMutation } from 'react-query';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useToast } from '@chakra-ui/react';
import { ERROR_TOAST_DEFAULTS } from '@helpers';
import { useCallback } from 'react';
import { translations } from 'translations';
import { useTranslation } from 'react-i18next';
import { useSession } from 'store/session';
import { AxiosError } from 'axios';

export const usePost = ({ token = undefined, inviteTeam = undefined }) => {
  const client = useClient({
    token: resolveTokenV3(token),
    url: process.env.REACT_APP_API_V3,
  });

  const toast = useToast();

  const { team } = useSession();

  const { t } = useTranslation();

  const teamUUID = inviteTeam ?? (team?.uuid as string);

  const fn = async (payload: IDocumentPostMetadata) => {
    const { folder, document } = payload;

    const response = await client.createDocumentV3(
      teamUUID,
      folder,
      document,
      payload,
    );
    return response;
  };

  const onError = useCallback(
    (error: AxiosError) => {
      let msg = t(translations.ERRORS.NETWORK_DEFAULT);
      if (error?.response?.status === 409) {
        msg = t(translations.DOCUMENT_PAGES.STATUS_CODE_409);
      }
      if (error?.response?.status === 402) {
        msg = t(translations.DOCUMENT_PAGES.STATUS_CODE_402);
      }
      if (error?.response?.status === 403) {
        msg = t(translations.ERRORS.PERMISSIONS);
      }
      toast({ ...ERROR_TOAST_DEFAULTS, title: msg });
    },
    [t, toast],
  );

  const mutation = useMutation('post-document', fn, { onError });

  return { ...mutation };
};
